import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { badgeDriverFactory } from './Badge.driver';
import { Badge, BadgePriority } from '.';
import { Camera as CameraIcon } from '@wix/wix-ui-icons-common/on-stage';

describe('Badge', () => {
  const createDriver = createRendererWithUniDriver(badgeDriverFactory);

  it('should render', async () => {
    const { driver } = createDriver(<Badge>I'm badge</Badge>);
    expect(await driver.exists()).toBe(true);
  });

  describe('Priorities', () => {
    it('should render default badge', async () => {
      const { driver } = createDriver(
        <Badge priority={BadgePriority.default}>I'm default badge</Badge>,
      );
      expect(await driver.isDefault()).toBeTruthy();
      expect(await driver.exists()).toBe(true);
    });
    it('should render light badge', async () => {
      const { driver } = createDriver(
        <Badge priority={BadgePriority.light}>I'm light badge</Badge>,
      );
      expect(await driver.isLight()).toBeTruthy();
      expect(await driver.exists()).toBe(true);
    });
    it('should render primary badge', async () => {
      const { driver } = createDriver(
        <Badge priority={BadgePriority.primary}>I'm primary badge</Badge>,
      );
      expect(await driver.isPrimary()).toBeTruthy();
      expect(await driver.exists()).toBe(true);
    });
    it('should render secondary badge', async () => {
      const { driver } = createDriver(
        <Badge priority={BadgePriority.secondary}>I'm secondary badge</Badge>,
      );
      expect(await driver.isSecondary()).toBeTruthy();
      expect(await driver.exists()).toBe(true);
    });
    it('should render badge with icon', async () => {
      const icon = <CameraIcon />;
      const { driver } = createDriver(
        <Badge icon={icon}>I'm primary badge</Badge>,
      );
      expect(await driver.hasIcon()).toBe(true);
    });
  });
});
